import React from 'react';
import entityIcons from '@/constants/images';
import NameCell from '@/components/table/NameCell';
import UserNameCell from '../../components/UserNameCell';
import memberEntities from '../constants';

const MemberNameCell = ({ member }) => (
  <>
    {member.entity !== memberEntities.USERGROUP && (<UserNameCell user={member} />)}
    {member.entity === memberEntities.USERGROUP && (
    <NameCell name={member.name} icon={entityIcons.usergroup} message="icon.usergroup" />
    )}
  </>
);

export default MemberNameCell;
